import { createAction, props } from '@ngrx/store';
export const setLookback = createAction('[Scatter Plot] Set Lookback', props());
